module.exports = __webpack_public_path__ + "img/xp5_002.b4abb8f3.jpg";